export default [
  {
    path: '/upgrade',
    name: 'PageSystemUpgrade',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/system/PageSystemUpgrade'
      ),
    meta: {
      modular: -1,
      info: '魔点校园——系统升级中对外展示',
      skipAnimation: true
    }
  },
  {
    path: '/drainage',
    name: 'PageDrainage',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageDrainage'),
    meta: { modular: -1, info: '魔点校园——去授权', skipAnimation: true }
  },
  {
    path: '/error',
    name: 'PageError',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageError'),
    meta: {
      modular: -1,
      info: '魔点校园——错误',
      skipAnimation: true
    }
  },
  // 其它
  {
    path: '/PageNoAuthotize',
    name: 'PageNoAuthotize',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/system/PageNoAuthotize'
      ),
    meta: { modular: -1, info: '魔点校园——未购买魔点门禁', skipAnimation: true }
  },
  {
    path: '/noSchoolInfo',
    name: 'PageNoSchoolInfo',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/system/PageNoSchoolInfo'
      ),
    meta: {
      modular: -1,
      info: '魔点校园——未开通家校通讯录',
      skipAnimation: true
    }
  },
  {
    path: '/pageLeading',
    name: 'PageLeading',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageLeading'),
    meta: { modular: -1, info: '魔点校园——购买门禁了解', skipAnimation: true }
  },
  {
    path: '/help',
    name: 'PageHelp',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageHelp'),
    meta: { modular: -1, title: '常见问题帮助', info: '魔点校园——常见问题帮助' }
  },
  {
    path: '/helpIndex',
    name: 'PageHelpIndex',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageHelpIndex'),
    meta: { modular: -1, title: '常见问题帮助', info: '魔点校园——常见问题帮助' }
  },
  {
    path: '/guide',
    name: 'PageGuide',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageGuide'),
    meta: { modular: -1, title: '设置引导', info: '魔点校园——设置引导页' }
  },
  {
    path: '/protocol',
    name: 'PageProtocolAuthorization',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/system/PageProtocolAuthorization'
      ),
    meta: { modular: -1, title: '授权协议', info: '魔点校园——第三方授权协议' }
  },
  {
    path: '/access',
    name: 'PageNoAccess',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/system/PageNoAccess'),
    meta: { modular: -1, info: '魔点校园——无权限' }
  },
  {
    path: '/semester',
    name: 'PageSchoolYearSemester',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/system/PageSchoolYearSemester'
      ),
    meta: { modular: -1, title: '学年学期', info: '魔点校园——学年学期' }
  }
]
